import { Button, Checkbox, Dropdown } from "antd";
import React, { useState } from 'react';
import Icon, { ICON_NAME } from "../../../../../components/Icon";
import { productionAreas, propContainer } from "../../../../../util/varibles/constants";
import { getProdAreaName } from "../../../../../util/varibles/global";
import { ISite } from "../../../../../util/varibles/interface";
import styles from "./style.module.scss";

interface IProps {
    prodAreaFilter: string[]
    sites: ISite[]
    siteFilter: number
    updateSetting(params: { prodAreaFilter: string[] }): void
}

const ProdAreaFilter: React.FC<IProps> = (props) => {
    const { prodAreaFilter, updateSetting, siteFilter, sites } = props;

    const [visible, setVisible] = useState(false);

    const handleVisibleChange = (visible: boolean) => setVisible(visible);

    const handleClear = () => {
        updateSetting({ prodAreaFilter: [] });
    }

    const handleChange = (value: string[]) => {
        updateSetting({ prodAreaFilter: value })
    }

    const items = [
        {
            className: styles.wrapper,
            key: 'filter',
            disabled: true,
            label: <div className='flex flex-col'>
                <div className={styles.header}>
                    <div className={styles.title}>
                        <div>Filter production area ({siteFilter}/{sites.length})</div>
                    </div>
                    <div className='link' onClick={handleClear}>Clear all filter</div>
                </div>
                <Checkbox.Group className={styles.productionAreas} value={prodAreaFilter} onChange={handleChange}>
                    {productionAreas.map(item => {
                        const { id, name } = item;
                        return <Checkbox className={styles.productionArea} key={item.id} value={item.id}>
                            {id ? getProdAreaName({ id, name }) : 'Other'}
                        </Checkbox>
                    })}
                </Checkbox.Group>
            </div>
        }
    ]
    return <Dropdown
        {...propContainer}
        open={visible}
        trigger={['click']}
        onOpenChange={handleVisibleChange}
        menu={{ items }}
        placement="bottom"
        arrow
        popupRender={(menus) => <>
            <div className={styles.layout} onClick={() => setVisible(false)}></div>
            {menus}
        </>}
    >
        <Button className='bt-ghost h-32' data-is-show={visible}>
            <Icon icon={ICON_NAME.FILTER} />
            <span className='ml-5'>Filter</span>
        </Button>
    </Dropdown>;
};

export default ProdAreaFilter;
